import { Box, Chip, Stack, Typography } from '@mui/material';

import useLocales from 'src/hooks/useLocales';

import { WorkflowDashboardRunDto } from 'src/@types/workflow/types';

import { activeStepOf, completedStepCount } from './dashboardRun';

const DETAIL_SEPARATOR = ' · ';

type DashboardWorkflowRunSummaryProps = {
  run: WorkflowDashboardRunDto;
  isWaitingOnMe: boolean;
};

export default function DashboardWorkflowRunSummary({
  run,
  isWaitingOnMe,
}: DashboardWorkflowRunSummaryProps) {
  const { t } = useLocales();

  const activeStep = activeStepOf(run);

  const details = [
    run.workflowName,
    t('dashboard.workflowRuns.stepCount', {
      done: completedStepCount(run),
      total: run.steps.length,
    }),
  ];

  if (activeStep && !isWaitingOnMe) {
    details.push(activeStep.assigneeEmail);
  }

  return (
    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        <Typography variant="subtitle2" noWrap sx={{ minWidth: 0 }}>
          {run.documentName}
        </Typography>

        {isWaitingOnMe && (
          <Chip
            size="small"
            color="warning"
            label={t('dashboard.workflowRuns.yourTurn')}
            sx={{ height: 20, flexShrink: 0 }}
          />
        )}
      </Stack>

      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {details.join(DETAIL_SEPARATOR)}
      </Typography>
    </Box>
  );
}
